import { useEffect, useState } from 'react';
import ExcelJS from 'exceljs';
import './ClientsSummary.css';
import CanvasJSReact from '@canvasjs/react-charts';
import { preferenceOptions } from '../../utilities/services/preferencesOptions';
import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';
import { getAllClients } from '../../utilities/api/clients';
 
// const CanvasJS = CanvasJSReact.CanvasJS;
const CanvasJSChart = CanvasJSReact.CanvasJSChart;

export default function ClientsSummary({user, clientsData, handleDropdownClick}) {
  const [annualData, setAnnualData] = useState([])
  const [clientsByProvince, setClientsByProvince] = useState([])
  const [isExportingSheet, setIsExportingSheet] = useState(false)
  const [exportSheetColumns, setExportSheetColumns] = useState([])
  

  const columnChartOptions = {
    title: {
      // text: "Clients by Province"
    },
    toolTip: {
      shared: true,
      contentFormatter: function (e) {
        let content = ''
        e.entries.forEach(entry => {
          content += `<strong>${entry.dataPoint.label}</strong>: ${entry.dataPoint.y} ${entry.dataPoint.y === 1 ? 'Client' : 'Clients'}<br>`
        })
        return content
      }
    },
    colorSet: "colorSet1",
    // dataPointMaxWidth: 50,
    axisY: {
      title: "Quantity",
      // suffix: "°F"
    },
    data: [{
      type: "column",
      dataPoints: [
      ...clientsByProvince
      ]
    }]
  }

  const areaChartOptions = {
    animationEnabled: true,
    theme: "light2",
    title: {
        // text: "Clients Added Monthly" 
    },
    axisX: {
        valueFormatString: "MMM",
        intervalType: "month",
        interval: 1
    },
    axisY: {
        title: "Quantity",
        // suffix: "°F"
    },
    toolTip: {
        shared: true,
        contentFormatter: function (e) {
          let content = ''
          e.entries.forEach(entry => {
            content += `<strong>${entry.dataSeries.name}</strong>: ${entry.dataPoint.y} ${entry.dataPoint.y === 1 ? 'Client' : 'Clients'}<br>`
          })
          return content
        }

    },
    legend: {
        cursor: "pointer",
        itemclick: function (e) {
            if (typeof (e.dataSeries.visible) === "undefined" || e.dataSeries.visible) {
                e.dataSeries.visible = false;
            } else {
                e.dataSeries.visible = true;
            }
            e.chart.render();
        }
    },
    data: annualData
  };

  // console.log(annualData)

  const handleExportSheetColumnChange = (evt) => {
    const column = evt.target.value
    if (exportSheetColumns.includes(column)) {
      setExportSheetColumns(exportSheetColumns.filter(item => item !== column))
    } else {
      setExportSheetColumns([...exportSheetColumns, column])
    }
  }

  const createExcelSheet = async () => {
    setIsExportingSheet(true)
    try {
      const clients = await getAllClients(user._id)
      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet('Clients');
      sheet.columns = [
        exportSheetColumns.includes('clientID') && { header: 'CLIENT ID', key: 'clientID', width: 20 },
        exportSheetColumns.includes('companyName') && { header: 'CLIENT NAME', key: 'companyName', width: 30 },
        exportSheetColumns.includes('companyEmail') && { header: 'EMAIL', key: 'companyEmail', width: 20 },
        exportSheetColumns.includes('companyPhoneNumber') && { header: 'PHONE', key: 'companyPhoneNumber', width: 20 },
        exportSheetColumns.includes('province') && { header: 'PROVINCE', key: 'province', width: 20 },
        exportSheetColumns.includes('companyAddress') && { header: 'ADDRESS', key: 'companyAddress', width: 20 },
        exportSheetColumns.includes('companyRepresentative') && { header: 'REPRESENTATIVES', key: 'companyRepresentative', width: 30 },
        exportSheetColumns.includes('createdAt') && { header: 'CREATION', key: 'createdAt', width: 20 },
        exportSheetColumns.includes('updatedAt') && { header: 'LAST UPDATE', key: 'updatedAt', width: 20 }
      ];
      sheet.getRow(1).font = { bold: true, size: 14 };
      clients.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).forEach(client => {
        sheet.addRow({
          clientID: parseInt(client.clientID),
          companyName: capitalizeFirstLetter(client.companyName),
          companyEmail: client.companyEmail,
          companyPhoneNumber: client.companyPhoneNumber? client.companyPhoneNumber : '---',
          province: client.province? client.province : '---',
          companyAddress: client.companyAddress? capitalizeFirstLetter(client.companyAddress) : '---',
          companyRepresentative: client.companyRepresentative? capitalizeFirstLetter(client.companyRepresentative.join(', ')) : '---',
          createdAt: new Date(client.createdAt).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }),
          updatedAt: new Date(client.updatedAt).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })
        })
      })
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Clients.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log(error)
    }
    setIsExportingSheet(false)
  }

useEffect(() => {
  const currentDate = new Date();
  const tempAnnualData = clientsData.annualData.map(data => {
    return {
        type: "area",
        name: (data.year).toString(),
        showInLegend: true,
        xValueFormatString: "MMMM",
        yValueFormatString: "#,##0",
        // Use default year of 2024, so that line charts are aligned
        dataPoints: [
          { date: new Date(data.year, 0), x: new Date(2024, 0), y: data.monthlyData.JAN },
          { date: new Date(data.year, 1), x: new Date(2024, 1), y: data.monthlyData.FEB },
          { date: new Date(data.year, 2), x: new Date(2024, 2), y: data.monthlyData.MAR },
          { date: new Date(data.year, 3), x: new Date(2024, 3), y: data.monthlyData.APR },
          { date: new Date(data.year, 4), x: new Date(2024, 4), y: data.monthlyData.MAY },
          { date: new Date(data.year, 5), x: new Date(2024, 5), y: data.monthlyData.JUN },
          { date: new Date(data.year, 6), x: new Date(2024, 6), y: data.monthlyData.JUL },
          { date: new Date(data.year, 7), x: new Date(2024, 7), y: data.monthlyData.AUG },
          { date: new Date(data.year, 8), x: new Date(2024, 8), y: data.monthlyData.SEP },
          { date: new Date(data.year, 9), x: new Date(2024, 9), y: data.monthlyData.OCT },
          { date: new Date(data.year, 10), x: new Date(2024, 10), y: data.monthlyData.NOV },
          { date: new Date(data.year, 11), x: new Date(2024, 11), y: data.monthlyData.DEC }
        ].filter(dataPoint => currentDate >= dataPoint.date).map(dataPoint => {
          return {x: dataPoint.x, y: dataPoint.y}
        })
      }
  })
  setAnnualData(tempAnnualData)

  const tempClientsByProvince = Object.keys(clientsData.clientsByProvince).map(province => {
    return {label: province, y: clientsData.clientsByProvince[province]}
  })
  setClientsByProvince(tempClientsByProvince)
}, [clientsData])

  return (
    <div className='ClientsSummary'>
        <div className='exportClientsContainer dropdown'>
          <button className='exportClients' title='Export Clients to Spreadsheet' id='exportClientsDropDownToggle' data-title='Export Clients' data-bs-toggle="dropdown" data-bs-auto-close='outside' aria-expanded="false">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="20px" fill='#FFFFFF'>
              <path d="M 28.90625 1.96875 C 28.863281 1.976563 28.820313 1.988281 28.78125 2 L 11.5 2 C 9.585938 2 8 3.558594 8 5.46875 L 8 43.90625 C 8 46.160156 9.867188 48 12.125 48 L 37.875 48 C 40.132813 48 42 46.160156 42 43.90625 L 42 15.1875 C 42.027344 15.054688 42.027344 14.914063 42 14.78125 L 42 14.5 C 42.007813 14.234375 41.90625 13.972656 41.71875 13.78125 L 30.21875 2.28125 C 30.027344 2.09375 29.765625 1.992188 29.5 2 L 29.1875 2 C 29.097656 1.976563 29 1.964844 28.90625 1.96875 Z M 11.5 4 L 28 4 L 28 12.34375 C 28 14.355469 29.644531 16 31.65625 16 L 40 16 L 40 43.90625 C 40 45.074219 39.054688 46 37.875 46 L 12.125 46 C 10.945313 46 10 45.074219 10 43.90625 L 10 5.46875 C 10 4.644531 10.660156 4 11.5 4 Z M 30 4.9375 L 39.0625 14 L 31.65625 14 C 30.722656 14 30 13.277344 30 12.34375 Z M 17 24 L 17 38 L 33 38 L 33 24 Z M 19 26 L 24 26 L 24 28 L 19 28 Z M 26 26 L 31 26 L 31 28 L 26 28 Z M 19 30 L 24 30 L 24 32 L 19 32 Z M 26 30 L 31 30 L 31 32 L 26 32 Z M 19 34 L 24 34 L 24 36 L 19 36 Z M 26 34 L 31 34 L 31 36 L 26 36 Z"/>
            </svg>
            <span>
              &nbsp;&nbsp;Export Clients
            </span>
          </button>
          <div className='dropdown-menu exportClientsDropDown' aria-labelledby="exportClientsDropDownToggle" onClick={handleDropdownClick}>
            <div className='description'>Select Fields to Export</div>
            <ul>
            { Object.keys(preferenceOptions['clients']).map((option, index) => (
              <li key={index} className='dropdown-item'>
                <div className='form-check'>
                    <input className='form-check-input' 
                      id={`clients-${option}-${index}`} 
                      type="checkbox" 
                      defaultChecked={false} 
                      value={option}
                      disabled={isExportingSheet}
                      onChange={handleExportSheetColumnChange} 
                    />
                    <label className='form-check-label' htmlFor={`clients-${option}-${index}`}>
                        {preferenceOptions['clients'][option]}
                    </label>
                </div>
              </li>
              ))}
            </ul>
            <div className='buttonContainer'>
              <button className='exportClients' onClick={createExcelSheet} disabled={isExportingSheet || exportSheetColumns.length===0}>
                Export
              </button>
            </div>
          </div>
        </div>
        <div className='annualClientInfo'>
          <div className='title1'>Monthly Data</div>
          <CanvasJSChart options = {areaChartOptions} />
          {/* <div className='hideWatermark'></div> */}
        </div>
        <div className='group'>
          <div className='clientsByProvince'>
            <div className='title1'>Province Distribution</div>
            <CanvasJSChart options = {columnChartOptions} />
            {/* <div className='hideWatermark'></div> */}
          </div>
          <div className='totalClients'>
            <div className='title1'>Total Clients</div>
            <div className='totalContainer'>
              <div className='total'>{clientsData.totalClients}</div>
            </div>
          </div>
        </div>
        
    </div>
  )
}
